import { fecthGet, fecthPost, fecthDelete } from '@/hotelcem/apis/request'

export default {
  // 查询数据源趋势
  fecthDataSourceTypeStatisticsTrend(params) {
    return fecthPost('/cem/hotel/data-source/type/statistics/trend', params)
  },
  /**
   * 客户需求一次解决率
   */
  fecthOnceResolveRatio(params) {
    const url = params.isGroup ? '/cem/multi/living/once/resolve/ratio' : '/cem/hotel/voice/once/resolve/ratio'
    return fecthPost(url, params)
  },
  /**
   * 触发客诉告警
   */
  fecthVoiceComplaintRate(params) {
    return fecthPost('/cem/hotel/voice/complaint/rate', params)
  },

  fecthVoiceComplaintRateNew(params) {
    const url = params.isGroup
      ? '/cem/multi/living/warn/complaint/distribute'
      : '/cem/hotel/voice/warn/complaint/distribute'
    return fecthPost(url, params)
  },
  /**
   * 告警及时查看率
   */
  fecthVoiceWarnInstantCheckRatioTrend(params) {
    return fecthPost('/cem/hotel/voice/warn/instant/check/ratio/trend', params)
  },
  /**
   * 告警查看率
   */
  fecthVoiceWarnCheckRatioTrend(params) {
    return fecthPost('/cem/hotel/voice/warn/check/ratio/trend', params)
  },
  /**
   * 告警查看率
   */
  fecthVoiceWarnInstantCheckRatioTrendNew(params) {
    const url = params.isGroup ? '/cem/multi/living/warn/check/ratio' : '/cem/hotel/voice/warn/check/ratio'
    return fecthPost(url, params)
  },
  /**
   * 质检得分
   */
  fecthQcExperienceScore(params) {
    return fecthPost('/cem/hotel/experience-score', params)
  },
  /**
   * 商圈排名
   */
  fecthQcAreaRank(params) {
    return fecthPost('/cem/hotel-rank/csi/biz-area-rank', params)
    // return fecthPost('/cem/hotel/biz-area-rank', params)
  },
  // fecthCsiQcAreaRank(params) {
  //   return fecthPost('/cem/hotel-rank/csi/biz-area-rank', params)
  // },
  /**
   * 未达标体验点
   */
  fecthQcUnreached(params) {
    return fecthPost('/cem/hotel/unreach', params)
  },
  /**
   * 综合体验得分趋势
   */
  fecthQcExperienceScoreTrend(params) {
    return fecthPost('/cem/hotel/experience/score/trend', params)
  },
  /**
   * 商圈排名趋势
   */
  fecthQcAreaRankTrend(params) {
    return fecthPost('/cem/hotel/biz-area/rank/trend', params)
  },
  fecthCsiQcAreaRankTrend(params) {
    return fecthPost('/cem/hotel-rank/csi/biz-area/rank/trend', params)
  },
  /**
   * 未达标体验点趋势
   */
  fecthQcUnreachedTrend(params) {
    return fecthPost('/cem/hotel/unreach/trend', params)
  },
  /**
   * 未达标体验点
   */
  fetchUnReachDetailList(params) {
    return fecthPost('/cem/hotel/unreach/detail/list', params)
  },
  /**
   * 点评分预测
   */
  fetchReviewPredict(params) {
    return fecthPost('/cem/hotel/voice/warn/score/prediction', params)
  },
  /**
   * 平均响应时长
   */
  fetchAvgTime(params) {
    const url = params.isGroup
      ? '/cem/multi/living/warn/response/time/length'
      : '/cem/hotel/voice/warn/response/time/length'
    return fecthPost(url, params)
  },
  // 住中语音总量-折线图
  fetchLiveVoiceTotal(params) {
    const url = params.isGroup ? '/cem/multi/living/voice-statistics-trent' : '/cem/living/voice-statistics-trent'
    return fecthPost(url, params)
  },
  fetchSublevelstatistics(params) {
    const url = params.isGroup
      ? '/cem/multi/living/period-voice-statistics-trent'
      : '/cem/living/period-voice-statistics-trent'
    return fecthPost(url, params)
  },
  // 住中语音分类-饼图
  fetchLiveVoiceClassification(params) {
    const url = params.isGroup ? '/cem/multi/living/voice-rate' : '/cem/living/voice-rate'
    return fecthPost(url, params)
  },
  // 住中语音统计数据
  fetchLiveVoicestatistics(params) {
    const url = params.isGroup ? '/cem/multi/living/voice-statistics' : '/cem/living/voice-statistics'
    return fecthPost(url, params)
  },
  // 会展信息
  fetchEventList(params) {
    return fecthPost('/cem/hotel/hot/event/list', params)
  },
  // 客诉投诉
  fetchComplaint(params) {
    return fecthPost('/cem/hotel/complaint', params)
  },
  // 导出详情数据
  fetchExport(params) {
    const url = params.isGroup
      ? '/cem/multi/living/period-voice-statistics-trent/export'
      : '/cem/living/period-voice-statistics-trent/export'
    return fecthPost(url, params)
  },
}
